export default __webpack_public_path__ + "static/media/Snd4.e14b7332.mp3";